'use strict';

exports.__esModule = true;
exports.presetLoader = presetLoader;

var _default = require('./default.json');

var _default2 = _interopRequireDefault(_default);

var _ds = require('./ds.json');

var _ds2 = _interopRequireDefault(_ds);

var _editor = require('./editor.json');

var _editor2 = _interopRequireDefault(_editor);

var _bolt = require('./bolt.json');

var _bolt2 = _interopRequireDefault(_bolt);

var _ooi = require('./ooi.json');

var _ooi2 = _interopRequireDefault(_ooi);

var _mobile = require('./mobile.json');

var _mobile2 = _interopRequireDefault(_mobile);

var _presetsTypes = require('./presets-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function presetLoader(presetType) {
  switch (presetType) {
    case _presetsTypes.presetsTypes.DEFAULT:
      return _default2.default;
    case _presetsTypes.presetsTypes.BOLT:
      return _bolt2.default;
    case _presetsTypes.presetsTypes.DS:
      return _ds2.default;
    case _presetsTypes.presetsTypes.EDITOR:
      return _editor2.default;
    case _presetsTypes.presetsTypes.OOI:
      return _ooi2.default;
    case _presetsTypes.presetsTypes.MOBILE:
      return _mobile2.default;
    default:
      return _default2.default;
  }
}